import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-sap-flags-item',
  templateUrl: './sap-flags-item.component.html',
  styleUrls: ['./sap-flags-item.component.scss']
})
export class SapFlagsItemComponent implements OnInit {

  @Input()
  flag: string;

  @Input()
  data: any;

  @Input()
  type: string;

  @Input()
  parent = null;

  constructor() { }

  ngOnInit() {
  }

}
